export async function createUserLicensingView(userDb: any, logger: any) {
    logger.info('create user licensing view index');

    const doc = {
      _id: '_design/user-licensing',
      views: {
        'activeusers-by-gym-company-coupon': {
          map: `
function (doc) {
 if (doc.currentPlanStatus == "active") {
  let gym = doc.gymName;
  if (!gym) {
    gym = "";
  }

  let company = "";
  if (doc.companyId) {
    company = doc.companyId;
  }

  let coupon = "";
  if (doc.stripeSubscriptionData && doc.stripeSubscriptionData.discountCodeApplied) {
    coupon = doc.stripeSubscriptionData.discountCodeApplied;
  }

  let email = doc.email;
  if (!email) {
    email = doc._id;
  }

  let employee = "";
  if (doc.employeeId) {
    employee = doc.employeeId;
  }

  let value = email + "," + employee; // useful for employee id recon

  emit([gym, company, coupon, doc.email], value);
 }
}
            `,
          reduce: '_count',
        },
      },
    };

    await userDb.put(doc);
  }
